var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2F5597"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70906 5.98127C7.42818 5.70599 6.97868 5.70599 6.69779 5.98127C6.4088 6.26451 6.4088 6.72987 6.69779 7.01311L10.0367 10.2854C10.8368 11.0696 10.8368 12.358 10.0367 13.1422L6.6978 16.4145C6.4088 16.6978 6.4088 17.1631 6.69779 17.4464C6.97868 17.7217 7.42818 17.7217 7.70906 17.4464L11.1262 14.0973C11.9039 13.3351 13.1484 13.3351 13.9261 14.0973L17.3432 17.4464C17.6241 17.7217 18.0736 17.7217 18.3545 17.4464C18.6435 17.1631 18.6435 16.6978 18.3545 16.4145L15.0156 13.1422C14.2155 12.358 14.2155 11.0696 15.0156 10.2854L18.3545 7.01311C18.6435 6.72987 18.6435 6.26451 18.3545 5.98127C18.0736 5.70599 17.6241 5.70599 17.3432 5.98127L13.9261 9.33034C13.1484 10.0925 11.9039 10.0925 11.1262 9.33034L7.70906 5.98127Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5a3dbb305aa36c86b5aba6df2b9b89ec.svg";
export { ForwardRef as ReactComponent };